import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import Banner from '@cpg-its/ads.containers.banner';
import { useSelector } from 'react-redux';
import React from 'react';
import { PageContainer } from '../../../../../../global/components/layout/page-container';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { MemberCoverageEnrollmentForm } from './member-coverage-enrollment-form';
import { useCurrentGhlFormId } from '../../hooks/useCurrentGhlFormId';
import { useMemberCoverageState } from '../../hooks/useMemberCoverageState';
import { gridPageStyles } from '../../../../../../global/constants/theme/styles/layout/grid-page-layout';
import { useMemberPensionEnrollmentInfo } from '../hooks/useMemberPensionEnrollmentInfo';
import { isNepEnrollment } from '../../hooks/isNepEnrollment';
import { ApiStatuses } from '../../../../../../global/models/api-model';
import { ApiErrorPage } from '../../../../../../global/components/api-error-page';


interface Props {
	basePath: string;
}

export function MemberCoverageEnrollment(props: Props) {
	const { basePath } = props;
	const newHirePropsLoaded = useSelector<TcsmStates, boolean>(state => state.epiProps?.newHireSettingsState?.contentLoaded);
	const newHireProps = useSelector<TcsmStates, NewHireProps>(state => state.epiProps?.newHireSettingsState?.epiContent);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);
	const currentForm = useCurrentGhlFormId();
	const coverageLoad = useMemberCoverageState(guid, currentForm?.id);
	const memberPensionEnrollmentInfoLoaded = useMemberPensionEnrollmentInfo();
	const pageClasses = gridPageStyles();
	const isNep = isNepEnrollment();
	const error = useSelector<TcsmStates, ApiStatuses>(state => state.newHireEnrollmentState?.apiError);


	function RenderLateEnrollmentWarning() {
		// TODO: Adjust condition
		const isLateEnrollment = true;

		if (!isLateEnrollment || !newHireProps?.lateEnrollmentCoverageWarningMessage) return null;

		return (
			<Banner
				banner={{
					type: 'warning',
					label: <p><strong>{newHireProps?.lateEnrollmentCoverageWarningMessage}</strong></p>,
				}} />
		);
	}

	if (error === ApiStatuses.Failure) {
		return <ApiErrorPage error={newHireProps?.unExpectedApiErorrMessage} />;
	}

	if (!isNep && !memberPensionEnrollmentInfoLoaded) {
		return <LoadingCircle />;
	}
	if (!newHirePropsLoaded || !coverageLoad) {
		return <LoadingCircle />;
	}

	return (
		<PageContainer>
			<div className={pageClasses.gridPageContainer}>
				<RenderLateEnrollmentWarning />
				<MemberCoverageEnrollmentForm basePath={basePath} />
			</div>
		</PageContainer>
	);
}